/* ==========================================================
   BAOBABE HIGHLIGHT STRIP
   Automatic classes, manual swiping and continuous scrolling
   ========================================================== */

(() => {
  const MOBILE_BREAKPOINT = '(max-width: 1097px)';
  const REDUCED_MOTION = '(prefers-reduced-motion: reduce)';

  /*
   * Automatic scrolling speed in pixels per second.
   * Smaller number = slower.
   */
  const AUTO_SCROLL_SPEED = 24;

  const highlightCardSelector = '[data-bb-highlight-card]';

  const trackSelector =
    '.bb-highlight-strip .bb-highlight-grid > .swipe__inner';

  /**
   * Automatically identify the relevant section,
   * grid and icon blocks.
   */
  function registerHighlightStrips(scope = document) {
    const highlightCards = [];

    if (
      scope.matches &&
      scope.matches(highlightCardSelector)
    ) {
      highlightCards.push(scope);
    }

    scope
      .querySelectorAll(highlightCardSelector)
      .forEach((card) => {
        highlightCards.push(card);
      });

    highlightCards.forEach((card) => {
      const group = card.closest('.group-block');
      const grid = card.closest('.grid-block');

      const section =
        grid?.closest('.section') ||
        card.closest('.section');

      if (!group || !grid || !section) return;

      section.classList.add('bb-highlight-strip');
      grid.classList.add('bb-highlight-grid');

      const iconBlock = group.querySelector('.icon-block');

      if (iconBlock) {
        iconBlock.classList.add('bb-highlight-icon');
      }
    });
  }

  /**
   * Prepare a duplicated carousel item.
   */
  function createClone(item, index, total, position) {
    const clone = item.cloneNode(true);

    clone.dataset.bbHighlightClone = position;
    clone.setAttribute('aria-hidden', 'true');

    if (index === total - 1) {
      clone.classList.add('bb-highlight-cycle-end');
    }

    if (clone.id) {
      clone.removeAttribute('id');
    }

    clone.querySelectorAll('[id]').forEach((element) => {
      element.removeAttribute('id');
    });

    clone
      .querySelectorAll(
        'a, button, input, select, textarea, [tabindex]'
      )
      .forEach((element) => {
        element.setAttribute('tabindex', '-1');
      });

    return clone;
  }

  /**
   * Create the continuous, manually scrollable carousel.
   */
  function initialiseHighlightStrips(scope = document) {
    scope.querySelectorAll(trackSelector).forEach((track) => {
      if (track.dataset.bbHighlightReady === 'true') return;

      const viewport = track.closest('.bb-highlight-grid');

      const originalItems = Array.from(track.children).filter(
        (item) => !item.dataset.bbHighlightClone
      );

      if (!viewport || originalItems.length < 2) return;

      track.dataset.bbHighlightReady = 'true';

      const totalItems = originalItems.length;
      const finalOriginal = originalItems[totalItems - 1];

      finalOriginal.classList.add(
        'bb-highlight-cycle-end'
      );

      originalItems.forEach((item) => {
        item.dataset.bbHighlightOriginal = 'true';
      });

      /*
       * Add one duplicated group before the originals.
       * This allows the user to swipe in either direction.
       */
      const beforeGroup = document.createDocumentFragment();

      originalItems.forEach((item, index) => {
        beforeGroup.appendChild(
          createClone(item, index, totalItems, 'before')
        );
      });

      track.insertBefore(beforeGroup, track.firstChild);

      /*
       * Add another duplicated group after the originals.
       */
      const afterGroup = document.createDocumentFragment();

      originalItems.forEach((item, index) => {
        afterGroup.appendChild(
          createClone(item, index, totalItems, 'after')
        );
      });

      track.appendChild(afterGroup);

      const mobileQuery =
        window.matchMedia(MOBILE_BREAKPOINT);

      const reducedMotionQuery =
        window.matchMedia(REDUCED_MOTION);

      const firstOriginal = originalItems[0];

      const firstAfterClone = track.querySelector(
        '[data-bb-highlight-clone="after"]'
      );

      let loopDistance = 0;
      let lastTimestamp = null;
      let pointerActive = false;
      let pauseUntil = 0;
      let positioned = false;
      let scrollRemainder = 0;

      /**
       * Pause automatic movement temporarily after
       * a user swipe or trackpad gesture.
       */
      function pauseAutomaticScroll(duration = 1000) {
        pauseUntil = performance.now() + duration;
      }

      /**
       * Measure one complete group of highlight items.
       */
      function updateMeasurements() {
        if (!firstOriginal || !firstAfterClone) return;

        loopDistance =
          firstAfterClone.offsetLeft -
          firstOriginal.offsetLeft;

        if (
          mobileQuery.matches &&
          loopDistance > 0 &&
          !positioned
        ) {
          viewport.scrollLeft = firstOriginal.offsetLeft;
          positioned = true;
        }

        if (!mobileQuery.matches) {
          positioned = false;
          viewport.scrollLeft = 0;
        }
      }

      /**
       * Move invisibly between duplicate groups to
       * maintain the endless loop.
       */
      function normaliseScrollPosition() {
        if (!mobileQuery.matches || loopDistance <= 0) {
          return;
        }

        if (viewport.scrollLeft >= loopDistance * 2) {
          viewport.scrollLeft -= loopDistance;
        } else if (viewport.scrollLeft <= 1) {
          viewport.scrollLeft += loopDistance;
        }
      }

      /**
       * Slowly advance the real scroll position.
       */
      function autoScroll(timestamp) {
        if (lastTimestamp === null) {
          lastTimestamp = timestamp;
        }

        const elapsed = Math.min(
          timestamp - lastTimestamp,
          50
        );

        const automaticMovementAllowed =
          mobileQuery.matches &&
          !reducedMotionQuery.matches &&
          !pointerActive &&
          timestamp > pauseUntil &&
          loopDistance > 0;

      if (automaticMovementAllowed) {
  scrollRemainder +=
    AUTO_SCROLL_SPEED * (elapsed / 1000);

  if (scrollRemainder >= 1) {
    const wholePixels = Math.floor(scrollRemainder);

    viewport.scrollLeft += wholePixels;
    scrollRemainder -= wholePixels;
  }
}

        normaliseScrollPosition();

        lastTimestamp = timestamp;
        requestAnimationFrame(autoScroll);
      }

      /* Pause while the user is touching or dragging */
      viewport.addEventListener(
        'pointerdown',
        () => {
          pointerActive = true;
        },
        { passive: true }
      );

      function endPointerInteraction() {
        pointerActive = false;
        pauseAutomaticScroll(1200);
      }

      viewport.addEventListener(
        'pointerup',
        endPointerInteraction,
        { passive: true }
      );

      viewport.addEventListener(
        'pointercancel',
        endPointerInteraction,
        { passive: true }
      );

      /*
       * Pause briefly when a trackpad or horizontal
       * mouse-wheel gesture is detected.
       */
      viewport.addEventListener(
        'wheel',
        (event) => {
          if (Math.abs(event.deltaX) > 0) {
            pauseAutomaticScroll(900);
          }
        },
        { passive: true }
      );

      requestAnimationFrame(() => {
        updateMeasurements();
        requestAnimationFrame(autoScroll);
      });

      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(
          updateMeasurements
        );

        observer.observe(viewport);
      }

      if (mobileQuery.addEventListener) {
        mobileQuery.addEventListener(
          'change',
          updateMeasurements
        );
      }
    });
  }

  /**
   * Register and initialise every highlight strip.
   */
  function setupHighlightStrips(scope = document) {
    registerHighlightStrips(scope);
    initialiseHighlightStrips(scope);
  }

  setupHighlightStrips();

  /*
   * Support Shopify theme-editor section refreshes.
   */
  document.addEventListener(
    'shopify:section:load',
    (event) => {
      setupHighlightStrips(event.target);
    }
  );
})();